import { FC, ReactNode } from 'react';
import { Grid, GridProps, Stack, Typography } from '@mui/material';

interface IStripedTableCellProps extends Omit<GridProps, 'title'> {
	title?: ReactNode;
	greyBg?: boolean;
}

export const StripedTableCell: FC<IStripedTableCellProps> = ({ title, greyBg, children, sx, ...props }) => {
	return (
		<Grid
			item
			xs={6}
			sx={{
				backgroundColor: greyBg ? '#f4f4f4' : 'common.white',
				paddingX: 4,
				paddingY: 3,
				display: 'flex',
				alignItems: title ? undefined : 'center',
				...sx
			}}
			{...props}
		>
			<Stack direction="column">
				{title && (
					<Typography variant="body2" sx={{ color: 'grey.800', marginBottom: 1.5 }}>
						{title}
					</Typography>
				)}
				{children}
			</Stack>
		</Grid>
	);
};
